export const base_url="https://backend.bipolarbharat.com"

const env_type = process.env.ENV_TYPE;
// export const base_url="http://localhost:3000"